(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-community"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bf-community')) customElements.define('bf-community', class extends HTMLElement {
 connectedCallback() {
  if(this.ready) return;
  this.ready = true;
  const filters = this.querySelector('[data-filters]');
  if(!filters) return;
  filters.hidden = false;
  const buttons = [...filters.querySelectorAll('button')];
  const stories = [...this.querySelectorAll('[data-story]')];
  buttons.forEach(button => button.addEventListener('click', () => {
   buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
   stories.forEach(story => {story.hidden = button.dataset.filter !== 'all' && story.dataset.story !== button.dataset.filter;});
   this.querySelector('[data-no-match]').hidden = stories.some(story => !story.hidden);
  }));
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-craft-world"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!document.body.classList.contains('template-index')) return;
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  const update = state => {
    const running = state.visible && !state.paused && !document.hidden && !motionPreference.matches;
    state.frame.classList.toggle('bf-motion-running', running);
    state.button.setAttribute('aria-label', state.paused ? state.play : state.pause);
    state.button.title = state.paused ? state.play : state.pause;
    state.button.textContent = state.paused ? '▶' : 'Ⅱ';
    state.button.hidden = motionPreference.matches;
  };
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    const state = states.get(entry.target);
    if (state) { state.visible = entry.isIntersecting; update(state); }
  }), { threshold: 0.05 });
  const setup = () => {
    const labels = document.querySelector('.bf-craft[data-motion-pause]');
    if (!labels) return;
    document.querySelectorAll('#MainContent .slideshow__image > img, #MainContent .banner__media .media > img, #MainContent .bf-craft__art > img').forEach((image, index) => {
      const frame = image.parentElement;
      if (states.has(frame)) return;
      frame.classList.add('bf-motion-frame');
      image.style.animationDelay = '-' + (index * 4) + 's';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bf-motion-toggle';
      const state = {frame, button, visible:false, paused:false, pause:labels.dataset.motionPause, play:labels.dataset.motionPlay};
      states.set(frame, state);
      button.addEventListener('click', event => { event.stopPropagation(); state.paused = !state.paused; update(state); });
      const controlHost = frame.closest('.banner') || (frame.classList.contains('media') ? frame.parentElement : frame);
      controlHost.appendChild(button);
      update(state);
      observer.observe(frame);
    });
    states.forEach((state, frame) => { if (!frame.isConnected) { observer.unobserve(frame); states.delete(frame); } });
  };
  document.addEventListener('visibilitychange', () => states.forEach(update));
  motionPreference.addEventListener('change', () => states.forEach(update));
  document.addEventListener('shopify:section:load', setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-explore"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bf-explore')) customElements.define('bf-explore', class extends HTMLElement {
 connectedCallback() {
  if (this.ready) return;
  this.ready = true;
  const button = this.querySelector('[data-share]');
  const status = this.querySelector('[data-share-status]');
  button.hidden = false;
  button.addEventListener('click', async () => {
   const url = window.location.href;
   const fallbackCopy = () => {
    const field = document.createElement('textarea');
    field.value = url;
    field.readOnly = true;
    field.style.cssText = 'position:fixed;top:0;left:-9999px;font-size:16px';
    document.body.appendChild(field);
    try {
     field.select();
     field.setSelectionRange(0, field.value.length);
     return document.execCommand('copy');
    } finally {
     field.remove();
     button.focus({preventScroll:true});
    }
   };
   status.textContent = '';
   let copied = false;
   try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
     await navigator.clipboard.writeText(url);
     copied = true;
    }
   } catch (error) {}
   if (!copied) {
    try { copied = fallbackCopy(); } catch (error) {}
   }
   status.textContent = copied ? status.dataset.copied : status.dataset.failed;
  });
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-random-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function shuffle(items) {
      const result = [...items];
      for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
      }
      return result;
    }

    function chooseProducts(pool, previous = []) {
      const unique = [...new Map(pool.map(item => [item.dataset.productId, item])).values()];
      const recent = new Set(previous);
      const fresh = shuffle(unique.filter(item => !recent.has(item.dataset.productId)));
      const repeated = shuffle(unique.filter(item => recent.has(item.dataset.productId)));
      const picks = shuffle([...fresh, ...repeated].slice(0, 4));
      if (picks.length > 1 && picks.every((item, index) => item.dataset.productId === previous[index])) {
        picks.push(picks.shift());
      }
      return picks;
    }

    async function loadPool(link, signal) {
      const base = new URL(link.href, window.location.origin);
      let url = new URL(base);
      url.searchParams.set('view', 'bf-random-pool');
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const visited = new Set();
      const products = new Map();
      while (url) {
        if (url.origin !== base.origin || url.pathname !== base.pathname || visited.has(url.href) || visited.size >= 500) {
          throw new Error('Invalid collection pagination');
        }
        visited.add(url.href);
        const response = await fetch(url.href, { signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const pool = doc.querySelector('[data-bf-pool]');
        if (!pool || pool.dataset.collection !== link.dataset.meaning) throw new Error('Unexpected collection');
        for (const card of pool.querySelectorAll('template[data-product-id]')) {
          if (card.content.querySelector('.bf-discover__product')) products.set(card.dataset.productId, card);
        }
        url = pool.dataset.next ? new URL(pool.dataset.next, base) : null;
        if (url) {
          url.searchParams.set('view', 'bf-random-pool');
          if (preview) url.searchParams.set('preview_theme_id', preview);
        }
      }
      return [...products.values()];
    }

    class BfRandomCollections extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.cache = new Map();
        this.previous = new Map();
        this.requestId = 0;
        this.links = [...this.querySelectorAll('[data-meaning]')];
        this.panel = this.querySelector('[data-results]');
        this.products = this.querySelector('[data-products]');
        this.status = this.querySelector('[data-status]');
        this.heading = this.querySelector('[data-result-heading]');
        this.refresh = this.querySelector('[data-refresh]');
        this.collectionLink = this.querySelector('[data-collection-link]');
        for (const link of this.links) {
          link.setAttribute('role', 'button');
          link.setAttribute('aria-expanded', 'false');
          link.setAttribute('aria-controls', this.panel.id);
          link.addEventListener('click', event => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.select(link, true);
          });
          link.addEventListener('keydown', event => {
            if (event.key === ' ') { event.preventDefault(); link.click(); }
          });
        }
        this.refresh.addEventListener('click', () => this.select(this.active, false));
      }

      disconnectedCallback() {
        this.requestId++;
        this.controller?.abort();
        this.busy = false;
      }

      async select(link, moveFocus) {
        if (!link || (this.busy && this.active === link)) return;
        const requestId = ++this.requestId;
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        this.active = link;
        this.busy = true;
        this.panel.hidden = false;
        this.products.replaceChildren();
        this.products.setAttribute('aria-busy', 'true');
        this.querySelector('[data-result-title]').textContent = link.dataset.title;
        this.collectionLink.href = link.href;
        this.status.textContent = this.dataset.loading;
        this.refresh.disabled = true;
        this.links.forEach(item => item.setAttribute('aria-expanded', String(item === link)));
        if (moveFocus) this.panel.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        const timeout = setTimeout(() => controller.abort(), 30000);
        try {
          const handle = link.dataset.meaning;
          let pool = this.cache.get(handle);
          if (!pool) {
            pool = await loadPool(link, controller.signal);
            if (requestId !== this.requestId) return;
            this.cache.set(handle, pool);
          }
          if (requestId !== this.requestId) return;
          const picks = chooseProducts(pool, this.previous.get(handle));
          this.previous.set(handle, picks.map(item => item.dataset.productId));
          this.products.replaceChildren(...picks.map(item => item.content.cloneNode(true)));
          this.status.textContent = pool.length === 0 ? this.dataset.empty : pool.length <= 4 ? this.dataset.small : this.dataset.ready;
          this.refresh.textContent = pool.length <= 4 ? this.dataset.shuffle : this.dataset.refresh;
          this.refresh.hidden = pool.length < 2;
          if (moveFocus) this.heading.focus({ preventScroll: true });
        } catch (error) {
          if (requestId !== this.requestId) return;
          this.status.textContent = this.dataset.error;
          this.refresh.textContent = this.dataset.refresh;
          this.refresh.hidden = false;
        } finally {
          clearTimeout(timeout);
          if (requestId === this.requestId) {
            this.busy = false;
            this.products.setAttribute('aria-busy', 'false');
            this.refresh.disabled = false;
          }
        }
      }
    }

    if (!customElements.get('bf-random-collections')) customElements.define('bf-random-collections', BfRandomCollections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-symbol-quiz"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bf-hoodie-match')) {
  customElements.define('bf-hoodie-match', class extends HTMLElement {
    async connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.mappings = JSON.parse(this.querySelector('[data-mappings]').textContent);
      this.products = JSON.parse(this.querySelector('[data-catalogue]').textContent);
      this.answers = {};
      this.index = 0;
      this.steps = ['outcome','secondary','family','design','colour','size'];
      this.form = this.querySelector('form');
      try {
        let next = this.querySelector('[data-next-page]').dataset.nextPage;
        const visited = new Set();
        while (next && !visited.has(next)) {
          visited.add(next);
          const url = new URL(next, location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Catalogue unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = doc.querySelector('[data-catalogue]');
          if (!payload) throw new Error('Catalogue unavailable');
          this.products.push(...JSON.parse(payload.textContent));
          next = doc.querySelector('[data-next-page]')?.dataset.nextPage;
        }
        this.products = [...new Map(this.products.map(p => [p.handle,p])).values()].filter(p => this.mappings[p.handle] && p.variants.length);
        this.querySelector('[data-loading]').hidden = true;
        this.form.hidden = false;
        this.showStep(0, false);
      } catch (error) {
        this.querySelector('[data-loading]').textContent = this.copy.load_error;
        return;
      }
      this.form.addEventListener('change', event => {
        if (!event.target.name) return;
        this.answers[this.steps[this.index]] = event.target.value;
        this.steps.slice(this.index + 1).forEach(key => delete this.answers[key]);
        this.querySelector('[data-error]').hidden = true;
      });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.answers[this.steps[this.index]]) {
          this.querySelector('[data-error]').hidden = false;
          this.querySelector('fieldset:not([hidden]) input, fieldset:not([hidden]) select')?.focus();
          return;
        }
        if (this.index < this.steps.length - 1) this.showStep(this.index + 1);
        else this.showResults();
      });
      this.querySelector('[data-back]').addEventListener('click', () => this.showStep(Math.max(0, this.index - 1)));
      this.querySelector('[data-edit]').addEventListener('click', () => {
        this.querySelector('[data-results]').hidden = true;
        this.form.hidden = false;
        this.showStep(0);
      });
      this.querySelector('[data-restart]').addEventListener('click', () => {
        this.answers = {};
        this.querySelector('[data-results]').hidden = true;
        this.form.hidden = false;
        this.showStep(0);
      });
    }
    meaningKeys() { return ['strength','freedom','transformation','connection','clarity','peace','growth','creativity']; }
    candidates() {
      return this.products.filter(p => {
        const m = this.mappings[p.handle];
        return m.meanings[this.answers.outcome] > 0 && (!this.answers.family || this.answers.family === 'any' || m.family === this.answers.family);
      });
    }
    optionIndex(product, kind) {
      return product.options.findIndex(name => kind === 'colour' ? /^(colou?r)$/i.test(name) : /^size$/i.test(name));
    }
    variantFits(product, variant, ignoreSize = false) {
      return ['colour', ...(ignoreSize ? [] : ['size'])].every(kind => {
        const answer = this.answers[kind];
        return !answer || answer === 'any' || variant.options[this.optionIndex(product, kind)] === answer;
      });
    }
    choices(key) {
      const c = this.copy;
      if (key === 'outcome') return this.meaningKeys().map(k => [k,c[k]]);
      if (key === 'secondary') return [['any',c.no_secondary], ...this.meaningKeys().filter(k => k !== this.answers.outcome).map(k => [k,c[k]])];
      if (key === 'family') return [['any',c.any], ...['nature','numbers','sacred','chakras','celestial','zodiac'].map(k => [k,c[k]])];
      if (key === 'design') return [['any',c.any_design], ...this.candidates().map(p => [p.handle,p.title]).sort((a,b) => a[1].localeCompare(b[1]))];
      const values = new Set();
      this.candidates().forEach(p => {
        const i = this.optionIndex(p,key);
        if (i >= 0) p.variants.filter(v => key !== 'size' || this.variantFits(p,v,true)).forEach(v => values.add(v.options[i]));
      });
      const order = ['XS','S','M','L','XL','2XL','XXL','3XL','4XL','5XL'];
      const sorted = [...values].sort((a,b) => key === 'size' ? (order.indexOf(a) < 0 ? 99 : order.indexOf(a)) - (order.indexOf(b) < 0 ? 99 : order.indexOf(b)) || a.localeCompare(b) : a.localeCompare(b));
      return [['any',c['any_'+key]], ...sorted.map(v => [v,v])];
    }
    el(tag,text,className) {
      const node = document.createElement(tag);
      if (text) node.textContent = text;
      if (className) node.className = className;
      return node;
    }
    showStep(index, focus = true) {
      this.index = index;
      const key = this.steps[index];
      this.querySelectorAll('fieldset').forEach(field => {
        field.hidden = field.dataset.step !== key;
        field.disabled = field.hidden;
      });
      const field = this.querySelector('[data-step="'+key+'"]');
      const box = field.querySelector('.bf-match__choices');
      box.replaceChildren();
      const choices = this.choices(key);
      if (this.answers[key] && !choices.some(([value]) => value === this.answers[key])) delete this.answers[key];
      if (key === 'design' || key === 'colour') {
        const select = this.el('select');
        select.name = key;
        select.setAttribute('aria-label', this.copy['q_'+key]);
        choices.forEach(([value,label]) => { const option = this.el('option',label); option.value = value; select.append(option); });
        select.value = this.answers[key] || 'any';
        this.answers[key] = select.value;
        box.append(select);
      } else choices.forEach(([value,label]) => {
        const wrap = this.el('label');
        const input = this.el('input');
        input.type = 'radio'; input.name = key; input.value = value;
        input.checked = this.answers[key] === value;
        wrap.append(input, this.el('span',label)); box.append(wrap);
      });
      this.querySelector('[data-progress]').textContent = this.copy.progress.replace('{step}',index+1).replace('{total}',this.steps.length);
      this.querySelector('progress').value = index + 1;
      this.querySelector('[data-back]').hidden = index === 0;
      this.querySelector('[data-next]').hidden = index === this.steps.length-1;
      this.querySelector('[data-finish]').hidden = index !== this.steps.length-1;
      this.querySelector('[data-error]').hidden = true;
      if (focus) field.querySelector('legend').focus();
    }
    ranked() {
      return this.candidates().map(p => {
        const meta = this.mappings[p.handle];
        const variant = p.variants.find(v => this.variantFits(p,v));
        const score = meta.meanings[this.answers.outcome] * 10 + (meta.meanings[this.answers.secondary] || 0) * 4 + (this.answers.design === p.handle ? 1000 : 0);
        return {p,meta,variant,score};
      }).filter(item => item.variant).sort((a,b) => b.score-a.score || a.p.title.localeCompare(b.p.title));
    }
    showResults() {
      const ranked = this.ranked();
      const selected = [];
      const symbols = new Set();
      ranked.forEach(item => {
        const symbol = item.meta.family === 'numbers' ? item.p.handle.slice(0,3) : item.p.handle;
        if (selected.length < 3 && !symbols.has(symbol)) { selected.push(item); symbols.add(symbol); }
      });
      const cards = this.querySelector('[data-cards]'); cards.replaceChildren();
      selected.forEach(({p,meta,variant},index) => {
        const article = this.el('article',null,'bf-match__card');
        const picture = variant.image || p.image;
        if (picture) { const img = this.el('img'); img.src = picture; img.alt = p.title; img.width = 720; img.height = 720; img.loading = 'lazy'; article.append(img); }
        const body = this.el('div',null,'bf-match__card-body');
        body.append(this.el('p',index ? this.copy.alternative : this.copy.best,'bf-match__badge'),this.el('h3',p.title),this.el('p',variant.price,'bf-match__price'),this.el('p',meta.evidence));
        body.append(this.el('h4',this.copy.why));
        const why = this.el('ul');
        why.append(this.el('li',this.copy.meaning_reason.replace('{meaning}',this.copy[this.answers.outcome])));
        if (meta.meanings[this.answers.secondary]) why.append(this.el('li',this.copy.secondary_reason.replace('{meaning}',this.copy[this.answers.secondary])));
        if (this.answers.family !== 'any') why.append(this.el('li',this.copy.family_reason.replace('{style}',this.copy[this.answers.family])));
        if (this.answers.design === p.handle) why.append(this.el('li',this.copy.design_reason));
        body.append(why,this.el('p',this.copy.options+': '+variant.title));
        const link = this.el('a',this.copy.view,'bf-match__primary');
        const url = new URL(p.url,location.origin); url.searchParams.set('variant',variant.id);
        link.href = url.pathname+url.search;
        body.append(link); article.append(body); cards.append(article);
      });
      const summary = this.querySelector('[data-summary]'); summary.replaceChildren();
      this.steps.forEach(key => {
        const label = this.choices(key).find(([value]) => value === this.answers[key])?.[1];
        if (label) summary.append(this.el('li',this.copy['q_'+key]+' '+label));
      });
      this.querySelector('[data-empty]').hidden = selected.length > 0;
      this.form.hidden = true;
      const results = this.querySelector('[data-results]'); results.hidden = false;
      results.querySelector('h2').focus();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
